const reveals = document.querySelectorAll("[data-reveal]");
const observer = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
        }
    });
}, {
    threshold: 0.2
});
reveals.forEach((el)=>observer.observe(el));
const faqItems = document.querySelectorAll(".faq-item");
faqItems.forEach((item)=>{
    item.addEventListener("click", ()=>{
        const active = item.classList.contains("active");
        faqItems.forEach((btn)=>btn.classList.remove("active"));
        if (!active) item.classList.add("active");
    });
});
const typingTarget = document.querySelector(".typing");
if (typingTarget) {
    const prefersReduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const rawTexts = typingTarget.dataset.texts;
    const texts = rawTexts ? rawTexts.split("|").map((item)=>item.trim()).filter(Boolean) : [
        typingTarget.dataset.text || typingTarget.textContent.trim()
    ];
    // Reserve max size to avoid layout shift while typing.
    const measureTextSize = (text)=>{
        const probe = document.createElement("span");
        const styles = window.getComputedStyle(typingTarget);
        probe.style.position = "absolute";
        probe.style.visibility = "hidden";
        probe.style.whiteSpace = "nowrap";
        probe.style.font = styles.font;
        probe.style.letterSpacing = styles.letterSpacing;
        probe.textContent = text;
        document.body.appendChild(probe);
        const rect = probe.getBoundingClientRect();
        probe.remove();
        return rect;
    };
    const maxSize = texts.reduce((acc, text)=>{
        const rect = measureTextSize(text);
        return {
            width: Math.max(acc.width, rect.width),
            height: Math.max(acc.height, rect.height)
        };
    }, {
        width: 0,
        height: 0
    });
    if (maxSize.width > 0) typingTarget.style.minWidth = `${Math.ceil(maxSize.width)}px`;
    if (maxSize.height > 0) typingTarget.style.minHeight = `${Math.ceil(maxSize.height)}px`;
    if (prefersReduce) typingTarget.textContent = texts[0] || "";
    else {
        typingTarget.textContent = "";
        let textIndex = 0;
        let charIndex = 0;
        let deleting = false;
        const tick = ()=>{
            const current = texts[textIndex] || "";
            if (!deleting) {
                typingTarget.textContent = current.slice(0, charIndex + 1);
                charIndex += 1;
                if (charIndex === current.length) {
                    deleting = true;
                    setTimeout(tick, 3000);
                    return;
                }
            } else {
                typingTarget.textContent = current.slice(0, charIndex - 1);
                charIndex -= 1;
                if (charIndex === 0) {
                    deleting = false;
                    textIndex = (textIndex + 1) % texts.length;
                }
            }
            setTimeout(tick, deleting ? 40 : 90);
        };
        tick();
    }
}
const liveCount = document.getElementById("liveCount");
if (liveCount) {
    const updateLiveCount = ()=>{
        const next = Math.floor(Math.random() * 13) + 3;
        liveCount.textContent = String(next);
    };
    updateLiveCount();
    setInterval(updateLiveCount, 180000);
}
const orderCount = document.getElementById("orderCount");
if (orderCount) {
    const baseCount = 24523;
    const dailyIncrease = 50;
    const baseDate = new Date(2026, 1, 22); // 2026-02-22 (local time)
    const updateOrderCount = ()=>{
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const diffMs = today.getTime() - baseDate.getTime();
        const diffDays = diffMs > 0 ? Math.floor(diffMs / 86400000) : 0;
        const next = baseCount + diffDays * dailyIncrease;
        orderCount.textContent = next.toLocaleString("en-US");
    };
    updateOrderCount();
}
const copyBtn = document.querySelector(".support-copy");
if (copyBtn && navigator.clipboard) copyBtn.addEventListener("click", async ()=>{
    const text = copyBtn.dataset.copy;
    try {
        await navigator.clipboard.writeText(text);
        copyBtn.textContent = "\u5DF2\u590D\u5236";
        setTimeout(()=>{
            copyBtn.textContent = "\u590D\u5236\u5FAE\u4FE1\u53F7";
        }, 2000);
    } catch  {
        copyBtn.textContent = "\u590D\u5236\u5931\u8D25";
        setTimeout(()=>{
            copyBtn.textContent = "\u590D\u5236\u5FAE\u4FE1\u53F7";
        }, 2000);
    }
});

//# sourceMappingURL=luodiye.ef756ed9.js.map
